import React from "react";
import styled from "styled-components";
import colors from "../constatns/colors";
import useWindowDimensions from "../constatns/size";
import { FaCircle } from "react-icons/fa";

import "../styles/home.css";

function RoadMapCard({title, innerContainerStyle, isRed, circleStyle, descriptionOne, descriptionTwo, descriptionThree, descriptionFour, containerStyle, titleStyle, rightBorder, topBorder}) {
    const { width } = useWindowDimensions();
    return(
    width <= 768 ? (
        rightBorder ?
        <Container width={width} style={{display: "block", marginBlock: 140, marginBottom: -50, ...containerStyle}}>

            <InnerContainer style={{display: "flex", marginTop: 20 }}>
                <MobileBorder style={{}}/>
                <FaCircle color={colors.grey} style={{fontSize: 10, marginTop: -7}}/>
                { isRed ?
                    <img alt="circle" style={{position: "absolute", marginLeft: -30, marginTop: -15, ...circleStyle}} src={require("../assets/images/redCircle.png")} />
                  : <img alt="circle" style={{position: "absolute", marginLeft: -30, marginTop: -15, ...circleStyle}} src={require("../assets/images/greyCircle.png")} />
                }
            </InnerContainer>

            <InnerContainer style={{}} >
                <Title style={titleStyle}>{title}</Title>
                <Description>{descriptionOne}</Description>
                <Description>{descriptionTwo}</Description>
                <Description>{descriptionThree}</Description>
                <Description>{descriptionFour}</Description>
            </InnerContainer>
            
             
        </Container>
        :
        <Container width={width} style={{display: "block"}}>

            <InnerContainer style={{ display: "flex", position: "relative", marginBlock: 10, marginRight: -10 }}>
                <FaCircle color={colors.grey} style={{fontSize: 10, float: "left", marginTop: -7, marginLeft: -5}}/>
                <MobileBorder style={{}}/>
                { isRed ?
                    <img alt="circle" style={{position: "absolute", right: -28, zIndex: 1, marginTop: -15, ...circleStyle }} src={require("../assets/images/redCircle.png")} />
                  : <img alt="circle" style={{position: "absolute", right: -28, zIndex: 1, marginTop: -15, ...circleStyle, }} src={require("../assets/images/greyCircle.png")} />
                }
            </InnerContainer>

            <InnerContainer style={{ marginBottom: 20, ...innerContainerStyle}} >
                <Title style={titleStyle}>{title}</Title>

                <Description>{descriptionOne}</Description>
                <Description>{descriptionTwo}</Description>
                <Description>{descriptionThree}</Description>
                <Description>{descriptionFour}</Description>
            </InnerContainer>
        </Container>
    )
    :
    (
        topBorder ?
        <Container width={width} style={containerStyle}>

            <InnerContainer >
                <Title style={titleStyle}>{title}</Title>
                <Description>{descriptionOne}</Description>
                <Description>{descriptionTwo}</Description>
                <Description>{descriptionThree}</Description>
                <Description>{descriptionFour}</Description>
            </InnerContainer>
            
             <InnerContainer style={{marginLeft: 10}}>
                <FaCircle color={colors.grey} style={{fontSize: 10, marginRight: -4}}/>
                <Border style={{height: 70}}/>
                { isRed ?
                    <img alt="circle" style={{position: "absolute" , marginLeft: -13, marginTop: 7, ...circleStyle}} src={require("../assets/images/redCircle.png")} />
                  : <img alt="circle" style={{position: "absolute", marginLeft: -13, marginTop: 7, ...circleStyle}} src={require("../assets/images/greyCircle.png")} />
                }
            </InnerContainer>
        </Container>
        :
        <Container width={width} style={{marginLeft: 70}}>

            <InnerContainer style={{ marginRight: 10}}>
                { isRed ?
                    <img alt="circle" style={{position: "absolute", marginTop: -37, marginLeft: -13, ...circleStyle }} src={require("../assets/images/redCircle.png")} />
                  : <img alt="circle" style={{position: "absolute", marginTop: -37, marginLeft: -13, ...circleStyle, }} src={require("../assets/images/greyCircle.png")} />
                }
                <Border style={{marginBottom: -5}}/>
                <FaCircle color={colors.grey} style={{fontSize: 10, marginRight: -5}}/>
            </InnerContainer>

            <InnerContainer style={innerContainerStyle} >
                <Description>{descriptionOne}</Description>
                <Description>{descriptionTwo}</Description>
                <Description>{descriptionThree}</Description>
                <Description>{descriptionFour}</Description>
                <Title style={titleStyle}>{title}</Title>
            </InnerContainer>
            
            
        </Container>

    )
    )
}

const Container = styled.div`
    display: flex;
    width: ${({width})=> width * 0.2}px;
    margin-left: 50px;
    @media (max-width: 768px) {
     width: ${({width})=> width * 0.3}px;
     margin-left: 20px;
    }
`

const InnerContainer = styled.div`
    /* margin-top: 50px ; */
    color: ${colors.white};
    text-align: right;
`

const Title = styled.h3`
    color: white;
    font-weight: 500;
    margin: 0px;
    margin-top: 5px;
    margin-bottom: 5px;
`

const Description = styled.p`
    color: ${colors.grey};
    font-size: 12px;
    margin: 0px;
`

const Border = styled.div`
    border-right: 0.5px solid ${colors.white};
    height: 110px;
    margin-top: -3px;
`

const MobileBorder = styled.div`
    border-top: 0.5px solid ${colors.white};
    width: 95%;
    margin: 0px;
    padding: 0px;
    margin-top: -3px;
`

export default RoadMapCard;
